/**
 * The save payload of a review in quantities: each row kept identified exactly as the weight review
 * sends it, with the quantity fields the quantity editor's save sends on top. A deleted row is left out.
 */
import type { ReviewTicker } from "@eu.mdotm.api/sphere";
import { withQuantityFields } from "$root/functional-areas/instruments-editor/quantity/serialize";
import { convertReviewInstrumentToReviewTicker, sanitizeReviewInstrument } from "../reviewRows";
import type { QuantityReviewRow } from "./rows";

export function convertQuantityReviewRows(rows: QuantityReviewRow[]): ReviewTicker[] {
	return rows
		.filter(sanitizeReviewInstrument)
		.map((row) => withQuantityFields(convertReviewInstrumentToReviewTicker(row), row));
}
